import { useToast } from '@chakra-ui/react';
import { showToast } from '@diamond/shared/ui';
import { useMemo } from 'react';

import { useUpdateLHCMutation } from '../hooks';
import type { EditLHCModalProps } from '../types';
import { LHCFormModal } from './lhc-form-modal';

function toDateInputValue(value: string): string {
  if (!value) return '';

  if (/^\d+$/.test(value)) {
    const unixSeconds = Number(value);
    if (!Number.isNaN(unixSeconds)) {
      return new Date(unixSeconds * 1000).toISOString().split('T')[0];
    }
  }

  const parsedDate = new Date(value);
  if (!Number.isNaN(parsedDate.getTime())) {
    return parsedDate.toISOString().split('T')[0];
  }

  return '';
}

export function EditLHCModal({
  isOpen,
  onClose,
  initialData,
  plantOptions,
  lastSyncedAt,
  onSync,
}: EditLHCModalProps) {
  const toast = useToast();

  const initialState = useMemo(() => {
    if (!initialData) {
      return {
        lhcNumber: '',
        lhcDate: '',
        collectionPlantId: '',
      };
    }

    return {
      lhcNumber: initialData.lhcNo,
      lhcDate: toDateInputValue(initialData.lhcDateRaw),
      collectionPlantId: initialData.collectionPlantId,
    };
  }, [initialData]);

  const updateLHCMutation = useUpdateLHCMutation();

  return (
    <LHCFormModal
      mode="edit"
      title="Ubah Laporan Harian Collection"
      name="edit-lhc-modal"
      isOpen={isOpen}
      onClose={onClose}
      submitLabel="Simpan"
      plantOptions={plantOptions}
      initialValues={{
        lhcNo: initialState.lhcNumber,
        lhcDate: initialState.lhcDate,
        collectionPlantId: initialState.collectionPlantId,
      }}
      isSubmitting={updateLHCMutation.isPending}
      requireDirty
      lastSyncedAt={lastSyncedAt}
      onSync={onSync}
      onSubmit={({ lhcNo, lhcDate, collectionPlantId }) => {
        if (!initialData) return;

        updateLHCMutation.mutate(
          {
            id: initialData.id,
            payload: {
              lhc_no: lhcNo,
              lhc_date: lhcDate,
              collection_plant_id: collectionPlantId,
            },
          },
          {
            onSuccess: () => {
              showToast(toast, 'success', 'LHC berhasil diperbarui');
              onClose();
            },
            onError: (error: Error) => {
              showToast(toast, 'error', error.message || 'Gagal memperbarui LHC');
            },
          }
        );
      }}
    />
  );
}
